export default __webpack_public_path__ + "static/media/Group55.cd3e9375.svg";